<template>
	<LazyHydrate when-visible>
		<layoutSection>
			<layoutPost type="full">
				<header>
					<p class="font-bold text-32 tablet:text-40 desktop:text-48">{{ title }}</p>
				</header>
				<div class="space-y-16">
					<p class="text-18 desktop:text-22 font-bold">Your car rental rate and Total Road Care package with GO Rentals include 24-hour AA roadside assistance and complimentary callout service for ALL types of breakdowns.</p>
					<p class="text-18 desktop:text-22">Your stress-free car rental experience is a priority and our <nuxt-link to="/services/rental-car-insurance/" class="link link-goBlue font-bold">insurance coverage</nuxt-link> has peace of mind built right in.</p>
				</div>
				<div class="grid grid-cols-1 desktop:grid-cols-3 gap-y-32 tablet:gap-x-32 tabletWide:w-8/12 desktop:w-auto">
					<article v-for="(insurance, index) in insurances" :key="index" class="space-y-24 tablet:space-y-32">
						<h3 class="font-bold text-24 text-goPink">{{ insurance.title }}</h3>
						<div class="space-y-16">
							<p v-for="detail in insurance.details" :key="detail.label" class="text-16">
								<strong class="font-bold">{{ detail.label }}</strong><br>{{ detail.value }}
							</p>
						</div>
					</article>
				</div>
				<div class="space-y-16">
					<h3 class="font-bold text-24 text-goPink">Electric Car Rental Insurance</h3>
					<p>Have peace of mind when you GO green! All of our coverage options cover our <nuxt-link to="/vehicles/electric-vehicles/" class="link link-goBlue font-bold">electric car fleet</nuxt-link> with the following amendments:</p>
					<ul class="space-y-4 text-16">
						<li class="bg-iconChevron pl-32">
							The Tesla dedicated roadside assistance must be utilised before our AA roadside assistance.
						</li>
						<li class="bg-iconChevron pl-32">
							A security bond on GO Basic and GO Assured insurance options will be required for a Tesla booking and therefore needs a credit card upon pick-up.
						</li>
					</ul>
					<p>For full details on the electric car insurance, please read our <nuxt-link to="/terms/" class="link link-goBlue font-bold">terms</nuxt-link>.</p>
				</div>
			</layoutPost>
		</layoutSection>
	</LazyHydrate>
</template>

<script>
import layoutSection from '~/components/layoutSection.vue'
import layoutPost from '~/components/layoutPost.vue'

export default {
	components: {
		layoutSection,
		layoutPost
	},
	props: {
		title: {
			type: String,
			default: "Rental Car Insurance Coverage",
		},
	},
	data() {
		return {
			insurances: [
				{
					title: 'GO Basic Insurance',
					details: [
						{
							label: 'Cost per day',
							value: '$0 extra cost. Included as standard in our rental fees which varies depending on the rental vehicle.'
						},
						{
							label: 'Excess',
							value: 'Excess liability paid by the hirer in the event of an accident or damage covered under the rental terms. The excess amount for this package is dependent on the vehicle selected.'
						},
						{
							label: 'Bond',
							value: 'A pre-authorised amount to be paid at pick-up and returned to hirer if no damage is caused. The bond amount differs depending on the vehicle and hire period selected.'
						},
						{
							label: 'Credit or Debit',
							value: 'A credit card with the main hirer’s name is required for this insurance option.'
						},
						{
							label: 'Cover',
							value: 'Full comprehensive cover including third-party liability, windscreen and tyre damage. The hirer is liable for the excess amount only if conditions under the agreement are met.'
						},
					]
				},
				{
					title: 'GO Assured',
					details: [
						{
							label: 'Cost per day',
							value: 'A fee per day will be charged for the full duration of your hire period depending on the rental vehicle. This is an insurance premium and non-refundable.'
						},
						{
							label: 'Excess',
							value: 'Excess is reduced from the maximum depending on the vehicle selected. This is only to be paid by the hirer in the event of an accident or damage covered under the rental terms.'
						},
						{
							label: 'Bond',
							value: 'Starting from $0 depending on the rental vehicle. A pre-authorised amount will be paid at pick-up and returned to hirer if no damage is caused.'
						},
						{
							label: 'Credit or Debit',
							value: 'A credit card with the main hirer’s name is only required for rental vehicles with a bond deposit.'
						},
						{
							label: 'Cover',
							value: 'Full comprehensive cover including third-party liability, windscreen and tyre damage. The hirer is liable for the excess amount only if conditions under the agreement are met.'
						},
					]
				},
				{
					title: 'GO Peace of Mind',
					details: [
						{
							label: 'Cost per day',
							value: 'A cost per day depends on the rental vehicle selected. The upgrade fee is an insurance premium and non-refundable.'
						},
						{
							label: 'Excess',
							value: 'From $0 excess liability and calculated based on the rental vehicle chosen. The hirer may have to pay an excess in the event of an accident or damage covered under the rental terms.'
						},
						{
							label: 'Bond',
							value: 'A credit card with the main hirer’s name is only required for rental vehicles with a bond deposit.'
						},
						{
							label: 'Credit or Debit',
							value: 'A credit card or debit card can be used.'
						},
						{
							label: 'Cover',
							value: 'Full comprehensive cover including third-party liability, windscreen and tyre damage.'
						},
					]
				},
			],
		}
	}
}
</script>

<style>

</style>
